export const Card = ({ children, className = "", ...p }) => (
  <div className={`rounded-2xl border border-slate-200 bg-white p-6 ${className}`} {...p}>{children}</div>
);

const TONES = {
  Active: "bg-emerald-50 text-emerald-700 border-emerald-200", Lifetime: "bg-violet-50 text-violet-700 border-violet-200", Complimentary: "bg-violet-50 text-violet-700 border-violet-200",
  "Quotation sent": "bg-sky-50 text-sky-700 border-sky-200", "New request": "bg-amber-50 text-amber-800 border-amber-200",
  "Grace period": "bg-orange-50 text-orange-700 border-orange-200", Scheduled: "bg-sky-50 text-sky-700 border-sky-200",
  Suspended: "bg-red-50 text-red-700 border-red-200", "Awaiting payment": "bg-amber-50 text-amber-800 border-amber-200",
  "Changes requested": "bg-orange-50 text-orange-700 border-orange-200", Ended: "bg-slate-100 text-slate-500 border-slate-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200", invited: "bg-sky-50 text-sky-700 border-sky-200",
  sent: "bg-amber-50 text-amber-800 border-amber-200", accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  activated: "bg-emerald-50 text-emerald-700 border-emerald-200", draft: "bg-slate-100 text-slate-600 border-slate-200",
  changes_requested: "bg-orange-50 text-orange-700 border-orange-200", paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  awaiting_payment: "bg-amber-50 text-amber-800 border-amber-200", pending_confirmation: "bg-sky-50 text-sky-700 border-sky-200",
  waived: "bg-violet-50 text-violet-700 border-violet-200", grace: "bg-orange-50 text-orange-700 border-orange-200",
  suspended: "bg-red-50 text-red-700 border-red-200", scheduled: "bg-sky-50 text-sky-700 border-sky-200",
};
const LABEL = { awaiting_payment: "awaiting payment", pending_confirmation: "transfer reported", changes_requested: "changes requested" };
export const Pill = ({ s, testid }) => (
  <span data-testid={testid} className={`inline-block rounded-full border px-2.5 py-0.5 text-[11px] font-semibold capitalize ${TONES[s] || "bg-slate-100 text-slate-500 border-slate-200"}`}>{LABEL[s] || s}</span>
);

export const Stat = ({ label, value, sub, tone = "text-[#0B2545]", testid }) => (
  <Card className="p-5" data-testid={testid}>
    <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold">{label}</p>
    <p className={`font-heading text-3xl font-bold mt-1 ${tone}`}>{value}</p>
    {sub && <p className="text-xs text-slate-500 mt-1">{sub}</p>}
  </Card>
);

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="text-xs font-semibold text-slate-600">{label}</span>
    <div className="mt-1">{children}</div>
  </label>
);

export const inputCls = "w-full h-10 rounded-lg border border-slate-300 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#1C6FE3]/40";
export const btn = "h-10 px-4 rounded-lg text-sm font-semibold inline-flex items-center justify-center gap-2 transition-colors disabled:opacity-50";
export const btnPrimary = `${btn} bg-[#1C6FE3] text-white hover:bg-[#1659b8]`;
export const btnDark = `${btn} bg-[#0B2545] text-white hover:bg-[#13315C]`;
export const btnOutline = `${btn} border border-slate-300 bg-white text-slate-700 hover:bg-slate-50`;

export const fmtDate = (s) => (s?.startsWith?.("2099-12-31") ? "Lifetime" : s ? new Date(s.length === 10 ? `${s}T00:00:00` : s).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—");
export const money = (n, c = "USD") => `${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })} ${c}`;
export const errMsg = (e) => (typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Something went wrong");
